/** Stable emoji avatar per logical player id (same glyph set as bluff). */

const GLYPHS = [
  "🐶",
  "🐱",
  "🐭",
  "🐹",
  "🐰",
  "🦊",
  "🐻",
  "🐼",
  "🐨",
  "🐯",
  "🦁",
  "🐮",
  "🐷",
  "🐸",
  "🐵",
  "🐔",
  "🐧",
  "🐦",
  "🦆",
  "🦉",
  "🦇",
  "🐺",
  "🦄",
  "🐝",
  "🦋",
] as const;

function hashString(s: string): number {
  let h = 0;
  for (let i = 0; i < s.length; i += 1) {
    h = Math.imul(31, h) + s.charCodeAt(i);
    h |= 0;
  }
  return Math.abs(h);
}

export function imposterOnlineAvatarEmoji(playerId: string): string {
  if (!playerId) return GLYPHS[0];
  return GLYPHS[hashString(playerId) % GLYPHS.length];
}
